import { appActions } from '../slices/app-slice';

export const setAppIsMobile = (isMobile) => {
  return (dispatch) => {
    dispatch(appActions.setIsMobile(isMobile));
  };
};

export const setAppNotification = (
  notificationMessage,
  notificationSeverity
) => {
  return (dispatch) => {
    dispatch(
      appActions.setNotification({ notificationMessage, notificationSeverity })
    );
  };
};

export const resetAppNotification = (isMobile) => {
  return (dispatch) => {
    dispatch(appActions.resetNotification());
  };
};
